import React, { useEffect, useState } from 'react';
import { Check, File, Filter, Loader2 } from 'lucide-react';
import { Campaign } from '../../types/client-management.types';
import { Company } from 'src/pages/billing/types/billing.types';

interface CampaignMultiSelectorProps {
  isLoading: boolean;
  campaigns: Campaign[];
  selectedCampaigns: Campaign[];
  onCampaignSelect: (campaign: Campaign) => void;
  companies: Company[];
}

const CampaignMultiSelector: React.FC<CampaignMultiSelectorProps> = ({
  isLoading,
  campaigns,
  selectedCampaigns,
  onCampaignSelect,
  companies,
}) => {
  const [campaignFilter, setCampaignFilter] = useState('');
  const [filteredCampaigns, setFilteredCampaigns] = useState<Campaign[]>([]);
  const [showOnlySelectedCampaigns, setShowOnlySelectedCampaigns] = useState(false);

  const handleCampaignFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCampaignFilter(e.target.value);
  };

  useEffect(() => {
    if (campaignFilter.length === 0) {
      setFilteredCampaigns(showOnlySelectedCampaigns ? selectedCampaigns : campaigns);
    } else {
      showOnlySelectedCampaigns ? setFilteredCampaigns(selectedCampaigns.filter((campaign) => campaign.title.toLowerCase().includes(campaignFilter.toLowerCase()))) : setFilteredCampaigns(campaigns.filter((campaign) => campaign.title.toLowerCase().includes(campaignFilter.toLowerCase())));
    }
  }, [campaignFilter, campaigns, selectedCampaigns, showOnlySelectedCampaigns]);
  return (
    <div className='w-1/3 bg-white rounded-md overflow-hidden shadow-sm mb-1'>
      <div className='flex flex-col'>
        <div className='flex flex-row items-center bg-gray-201 font-medium text-black p-2 gap-2 pl-4 borber-b border-yellow-500 border-b-2 pb-1'>
          <File className='size-4' />
          <span className=''>
            Campaigns
          </span>
          <div className='flex flex-row items-center gap-2 ml-auto'>
            {selectedCampaigns.length > 0 && showOnlySelectedCampaigns ? (
              <Filter
                className='size-5 cursor-pointer text-white bg-blue-500 rounded-sm p-0.5'
                onClick={() => setShowOnlySelectedCampaigns(!showOnlySelectedCampaigns)}
              />
            ) : (
              <Filter
                className='size-4 cursor-pointer'
                onClick={() => setShowOnlySelectedCampaigns(!showOnlySelectedCampaigns)}
              />
            )}
          </div>
        </div>
        {isLoading ? (
          <div className='flex flex-row items-center gap-2 h-[200px] justify-center'>
            <Loader2 className='size-10 animate-spin' />
          </div>
        ) : (
          <div className='flex flex-col h-[200px] bg-white no-wrap overflow-y-auto'>
            <input
              type="text"
              onChange={handleCampaignFilter}
              placeholder='Search campaigns'
              className='w-full border-b border-gray-201 bg-white px-2 py-1 mr-2 mb-1 text-sm focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-transparent'
            />
            { filteredCampaigns.length > 0 ? filteredCampaigns.map((campaign) => (
              <div
                key={campaign.id}
                onClick={() => onCampaignSelect(campaign)}
                className='flex flex-row items-center text-sm py-1 cursor-pointer hover:bg-gray-201'
              >
                <div className='flex-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                  <div className='truncate'>
                    {campaign.title}
                  </div>
                  <div className='text-xs text-blue-500'>
                    <span className='mr-2'>
                      {companies.find((company) => company.id === campaign.company)?.company_name || 'Undefined'}
                    </span>
                    <span className='text-xs text-green-501'>
                      {campaign.account.title}
                    </span>
                    <span className='text-xs text-gray-500 ml-1 p-1 px-2 underline'>
                      {campaign.platform.toLocaleLowerCase().replace('_', ' ')}
                    </span>
                  </div>
                </div>
                {selectedCampaigns.includes(campaign) ? <Check className='size-4 mr-2 flex-shrink-0 text-green-501' /> : null}
              </div>
            )) : (
              <div className='text-sm text-gray-500 text-center h-[200px] flex items-center justify-center'>
                <File className='size-4 mr-1' />
                No campaigns found
              </div>
            ) }
          </div>
        )}
      </div>
    </div>
  );
};

export default CampaignMultiSelector;
